const _import = require("./_import");
export const asyncRouterHandle = (asyncRouter: any[]) => {
  asyncRouter.map((item) => {
    if (item.component) {
      item.component = _import(item.component);
    } else {
      delete item["component"];
    }
    if (item.children) {
      asyncRouterHandle(item.children);
    }
  });
};
